import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { getTextoMulta } from './utils'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import { TEXTO_MULTA } from './constants'

const TextoWrapper = styled.div`
  max-width: 74%;
  margin-bottom: 10px;

  @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
    max-width: 100%;
  }

  p {
    width: 800px;
    margin: 5px 0;
    white-space: pre-line;

    @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
      width: 100%;
    }
  }

  p:first-child {
    margin-bottom: 20px;
  }
`

const TextoMulta = ( { category, valorMulta, quantidadeKitsMulta } ) => (
  <TextoWrapper>
    <p>{ getTextoMulta( category, valorMulta, quantidadeKitsMulta ) }</p>

    <p>{ quantidadeKitsMulta === 1 ? TEXTO_MULTA : '' }</p>
  </TextoWrapper>
)

TextoMulta.propTypes = {
  'category': PropTypes.string.isRequired,
  'quantidadeKitsMulta': PropTypes.number.isRequired,
  'valorMulta': PropTypes.number.isRequired,
}

export default TextoMulta
